import { getSchemaFilePath } from '@wix/wix-data-client-common'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'

export default ({ hostname, logger, editorSdkProxy, experimentsManager }) => {
  const isConnectExternalDBNewFlow = experimentsManager.enabled(
    'specs.wixDataClient.connectExternalDBNewFlow',
  )

  return async (namespace, isEditFlow) => {
    const { width, height } = isConnectExternalDBNewFlow
      ? isEditFlow
        ? { width: '660', height: '515' }
        : { width: '600', height: '638' }
      : { width: '660', height: '520' }
    const url = await getPanelUrl({
      hostname,
      relativeUrl: 'externalDbDriver.html',
      editorSdkProxy,
    })
    const panelResult = await editorSdkProxy.editor
      .openModalPanel({
        url,
        width,
        height,
        shouldHideHeader: true,
        initialData: { namespace },
      })
      .catch(error => {
        logger.error(
          new Error('Failed to open external DB driver panel', {
            cause: error,
          }),
        )
      })

    if (panelResult) {
      const isTreePaneOpen = await editorSdkProxy.ide.treePane.isOpen()
      if (!isTreePaneOpen) {
        await editorSdkProxy.ide.treePane.toggle()
      }

      editorSdkProxy.ide.openFile({
        path: getSchemaFilePath(panelResult.collectionId),
      })
    }
  }
}
